import { CustomPropertyType } from '@evidentid/tprm-portal-lib/models/dashboard';

export const FIELD_TYPE_LABELS: Record<string, string> = {
    [CustomPropertyType.integer]: 'Integer',
    [CustomPropertyType.number]: 'Number',
    [CustomPropertyType.boolean]: 'Boolean',
    [CustomPropertyType.string]: 'Text',
    [CustomPropertyType.email]: 'Email',
    [CustomPropertyType.listString]: 'List Text',
    [CustomPropertyType.listEmail]: 'List Email',
    [CustomPropertyType.collaterals]: 'Collaterals',
    [CustomPropertyType.equipment]: 'Equipment',
    [CustomPropertyType.credentialTypes]: 'Credential Types',
    [CustomPropertyType.address]: 'Address',
    [CustomPropertyType.enum]: 'Dropdown',
};
